import {
    GET_USERS,
    GET_USERS_SUCCESS,
    GET_USERS_SUCCESS_FAILED
} from './actionTypes';

export const getUsers = (pages) => {
    return {
        type: GET_USERS,
        payload: pages
    }
}

export const getUsersSuccess = (users) => {
    return {
        type: GET_USERS_SUCCESS,
        payload: users
    }
}

export const getUsersFailed= () => {
    return {
        type: GET_USERS_SUCCESS_FAILED
    }
}
